import { Component, OnInit, output, inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './conversational-chat-inactivityprompt.content.json';

@Component({
    selector: 'conversational-chat-inactivityprompt',
    templateUrl: './conversational-chat-inactivityprompt.component.html',
    standalone: false
})
export class ConversationalChatInactivitypromptComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    public promptSelectContinue = output<void>();
    public promptSelectEnd = output<void>();

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    public setSelectContinue(): void {
        this.promptSelectContinue.emit();
    }

    public setSelectEnd(): void {
        this.promptSelectEnd.emit();
    }
}
